import React, { useEffect, useRef } from "react";
import { Text2xl, TextLg, TextMd, TextSm } from "../../components/text";
import { useAppContext } from "../../context/appContext";
import { SeeMore } from "../home/components/seeMore";
import { InteractiveDashboards } from "./components/interactiveDashboards";
import { ReportingAutomation } from "./components/reportingAutomation";
import { BusinessIntelligence } from "./components/businessIntelligence";
import { FadeInSection } from "../../components/fadeInSection/fadeInSection";
import { ImageContainer } from "../../components/imageContainer";

export const DataAnalytics = () => {
  const { routing, setPageLoading } = useAppContext();
  const { navigate } = routing;

  useEffect(()=>{
    setPageLoading(true);
  },[]);

  return (
    <div className="bg-blue-50">
      <div className="relative flex flex-col overflow-hidden">
        <ImageContainer 
          url="/images/data-center.png"
          onLoad={()=>{
            setPageLoading(false);
          }}
        />

        <div className="absolute inset-0 backdrop-blur-[6px] flex items-center justify-center text-gray-100 bg-black/25">
          <div className="flex flex-col items-center gap-3 text-center px-9">
            <Text2xl className="font-bold select-none">Data Analytics</Text2xl>

            <TextMd className="font-medium max-w-2xl text-center select-none text-slate-200">
              Interactive dashboards, reporting automation, and actionable
              insights built from your datasets.
            </TextMd>
          </div>
        </div>
      </div>

      <div className="p-9 flex flex-col items-center">
        <TextMd className="flex flex-wrap items-center justify-center gap-x-1.5 lg:gap-x-2 *:my-auto">
          <TextLg className="font-bold bg-gradient-to-r from-blue-500 via-cyan-500 to-blue-600 bg-clip-text text-transparent">
            Transforming
          </TextLg>

          <span>data</span> 
          <span>into</span> 
          <span>clear</span> 
          <span>business</span> 
          <span>direction.</span>
        </TextMd>

        <TextSm className="text-slate-500 leading-7 mt-4 font-medium max-w-[80%] text-center">
          Analytics solutions designed to simplify complex datasets,
          automate reporting workflows, and provide actionable insights that
          support better business decisions.
        </TextSm>
      </div>

      <div className="flex flex-col">
        <FadeInSection left threshold={0.25} className="m-1">
          <InteractiveDashboards className="p-9" />
        </FadeInSection>
        
        <div className="h-px mx-9 bg-neutral-500/15" />
        
        <FadeInSection left threshold={0.25} className="m-1">
          <ReportingAutomation className="p-9" />
        </FadeInSection>
        
        <div className="h-px mx-9 bg-neutral-500/15" />
        
        <FadeInSection left threshold={0.25} className="m-1">
          <BusinessIntelligence className="p-9" />
        </FadeInSection>
      </div>
    </div>
  );
};
